export enum WorkOrderCalendarDateType {
  Entry = 'domain.enums.work_order_date_type.entry',
  Authorization = 'domain.enums.work_order_date_type.authorization',
  Close = 'domain.enums.work_order_date_type.close',
  Estimated = 'domain.enums.work_order_date_type.estimated',
  Return = 'domain.enums.work_order_date_type.return',
}
